import { computed, shallowRef } from 'vue';
import axios from 'axios';
import {
  BorrowerLocate,
  BorrowerLocatesResponse,
  RawBorrowerLocatesResponse,
} from '@/modules/borrower/models';
import { BorrowerLocatePayload } from '@/utils/api/locates';
import { RestOperation } from '@/utils/helpers/rest';

// Module-level state (singleton pattern)
const borrowerLocates = shallowRef<BorrowerLocate[]>([]);

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useBorrowerLocates() {
  async function fetchBorrowerLocates(): Promise<void> {
    const { data } = await axios.get<RawBorrowerLocatesResponse>('/api/1/borrower/locates');
    const response = BorrowerLocatesResponse.fromData(data);
    borrowerLocates.value = response.locates;
  }

  async function submitBorrowerLocate(
    locate: BorrowerLocate,
    crudAction: RestOperation
  ): Promise<void> {
    if (locate.security == null) return;

    const payload: BorrowerLocatePayload = {
      equityId: locate.security.id,
      quantity: locate.quantity,
    };

    switch (crudAction) {
      case RestOperation.Create:
        await axios.post('/api/1/borrower/locates', payload);
        break;
      default:
        throw new Error(`submitBorrowerLocate: operation '${crudAction}' not supported`);
    }
    await fetchBorrowerLocates();
  }

  async function checkOffLocate(locate: BorrowerLocate): Promise<void> {
    if (locate.security == null) return;
    await axios.put(`/api/1/borrower/locate/${locate.security.id}/check-off`);
    await fetchBorrowerLocates();
  }

  return {
    borrowerLocates: computed(() => borrowerLocates.value),
    fetchBorrowerLocates,
    submitBorrowerLocate,
    checkOffLocate,
  };
}
